// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/summary */
export async function summaryControllerUpdate(
	body: API.SummaryUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/summary', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/summary/${param0} */
export async function summaryControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.SummaryControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.SummaryViewResponse>(`/api/summary/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/summary/${param0} */
export async function summaryControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.SummaryControllerCreateParams,
	body: API.SummaryCreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/summary/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
